import { GenericSelect } from "../../../../../shared/components/AppGenericSelect";
import { AppLabel } from "../../../../../shared/components/AppLabel";
import { AppNewInput } from "../../../../../shared/components/AppNewInput";
import { MODERATOR_OPTIONS } from "../../constants";
import styles from "./styles.module.css";

interface Props {
  userFullName: string;
  userTable: string | null;
  onNameChange: (v: string) => void;
  onTableChange: (v: string | null) => void;
  className?: string;
}

export const ProfileForm = ({
  userFullName,
  userTable,
  onNameChange,
  onTableChange,
}: Props) => {
  return (
    <div className={styles["container"]}>
      <div className={styles["ident-input-wrapper"]}>
        <div className={styles["input-name"]}>
          <AppLabel>Фамилия и имя</AppLabel>
          <AppNewInput
            value={userFullName}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder={"Введите фамилию и имя"}
          />
        </div>
        <div className={styles["input-table"]}>
          <AppLabel>Стол</AppLabel>
          <GenericSelect<string>
            options={MODERATOR_OPTIONS}
            value={userTable}
            onChange={(o) => onTableChange(o)}
            getLabel={(option) => option}
            getValue={(option) => option}
            placeholder="Номер стола"
          />
        </div>
      </div>
    </div>
  );
};
